<template>
  <div :class="$style.modal">
    <div :class="$style.modal__content">
      <img :src="url" alt="QR Code" :class="$style.modal__image" />
    </div>
    <div :class="$style.modal__buttonArea">
      <FlatButton variant="plain" size="medium" @click="$emit('close')">
        閉じる
      </FlatButton>
      <FlatButton
        variant="primary"
        size="medium"
        :disabled="loading || !objURL"
        @click="download"
      >
        <span v-if="loading"> <LoadingIndicator /> </span>
        <span v-else>ダウンロード</span>
      </FlatButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted } from 'vue'
import FlatButton from '@/components/atoms/FlatButton.vue'
import { useAlert } from '@/libs/alertPortal'
import LoadingIndicator from '@/components/atoms/LoadingIndicator.vue'

const props = defineProps<{ url: string }>()
const alert = useAlert()

const objURL = ref<string>() // ダウンロードリンク
const loading = ref(true)

// コンポーネントがマウントされたときに、APIからQRコードのダウンロードリンクを準備（APIが少し遅いので）
onMounted(async () => {
  try {
    const response = await fetch(props.url)
    const blob = await response.blob()
    objURL.value = window.URL.createObjectURL(blob)
  } catch {
    alert.error('QRコードのダウンロードに失敗しました')
  } finally {
    loading.value = false
  }
})

onUnmounted(() => {
  if (objURL.value) {
    window.URL.revokeObjectURL(objURL.value)
  }
})

// ダウンロード処理
const download = () => {
  if (!objURL.value) return

  const link = document.createElement('a')
  link.href = objURL.value
  link.download = `qr.png`
  link.click()
}
</script>

<style lang="scss" module>
.modal {
  padding: 20px;
  border-radius: 8px;
  text-align: center;
  background: white;

  &__content {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 150px;
  }

  &__image {
    max-width: 100%;
    max-height: 300px;
    margin-bottom: 16px;
  }

  &__buttonArea {
    display: flex;
    justify-content: center;
  }
}
</style>
